module.exports = __webpack_public_path__ + "img/wat-phra-kaew.17f9dc8c.svg";